import React from 'react';
import { Box } from '@mui/material';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckRounded';
import { IGroup } from '../../../store/reducers/createService';
import { IQuestion } from '../../../models/iquestion';
import { IServiceQuestion } from '../../../models/iserviceQuestion';

type Props = {
  group: IGroup<IQuestion | IServiceQuestion>,
}

const GroupHeader: React.FC<Props> = ({ group }) => {
  return <>
    <Box sx={styles.groupName}>
      {group.name}
      {group.totalScore > 0 &&
        <Box sx={styles.score}>
          <Box sx={styles.scoreText}>
            {`${(group.score/group.totalScore * 100).toFixed(2)}%`}
          </Box>
          <PlaylistAddCheckCircleIcon />
        </Box>
      }
    </Box>
  </>
}

const styles = {
  groupName: {
    fontSize: 16,
    marginTop: '10px',
    backgroundColor: '#e4e4e4',
    textAlign: 'start',
    paddingTop: '12px',
    paddingBottom: '12px',
    position: 'relative',
    paddingLeft: '24px',
    paddingRight: '24px',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    marginBottom: '26px',
    color: '#6F8189',
  },
  score: {
    position: 'absolute',
    paddingTop: '4px',
    paddingRight: '8px',
    top: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  scoreText: {
    fontWeight: 'bold',
    marginRight: '8px'
  },
}

export default GroupHeader;
